/* global WEB_ROOT */
import moment from 'moment';

import { formatDateLong, formatNumber, formatPrice } from '../../utils/formats';

import organiserResolver from './organiser';
import raceResolver from './race';

/**
 * Event detail resolver.
 * This pure function annotates event detail objects with computed values, e.g. formatted strings.
 */
const resolver = event => event && {
  ...event,
  permalink: `/e/${event.slug}-${event.id}`,
  canonical: `${WEB_ROOT}/e/${event.slug}-${event.id}`,
  // Format start date, optional
  ...(event.startDate && {
    startDateFormatted: formatDateLong(event.startDate),
    startMonth: moment(event.startDate).format('MMM').toUpperCase(),
    startDay: moment(event.startDate).format('D')
  }),
  // Organiser is optional
  ...(event.organiser && {
    organiser: organiserResolver(event.organiser),
  }),
  // Races are optional
  ...(event.races && {
    races: {
      ...event.races,
      // Format from price, optional (number)
      ...(typeof event.races.pricesFrom !== 'undefined' && {
        pricesFromFormatted: formatPrice(event.races.currencyLabel, event.races.pricesFrom),
      }),
      // Format to price, optional (number)
      ...(typeof event.races.pricesTo !== 'undefined' && {
        pricesToFormatted: formatPrice(event.races.currencyLabel, event.races.pricesTo),
      }),
      races: event.races.races.map(race => ({
        ...raceResolver(race),
        canonical: `${WEB_ROOT}/e/${event.slug}-${event.id}`,
      })),
    },
    // Relive ID should be at but is nested inside races
    reliveId: event.races.races[0].reliveID,
  }),
  // Reviews are optional
  ...(event.reviews && {
    reviews: {
      ...event.reviews,
      // Format total reviews, required (number)
      totalFormatted: formatNumber(event.reviews.total),
    },
  }),
  geometry: {
    coordinates: [event.location.lat, event.location.long]
  },
};

export default resolver;



// WEBPACK FOOTER //
// ./app/src/state/resolvers/event.js